import {
  doubleIndexChecker,
  layoutJumps,
} from '@Components/BigBrowse/Views/DetailViews/MultiSectionView/footer/helpers/footer.helpers';
import { addShelfDisplaceGaps } from '@Components/BigBrowse/Views/DetailViews/MultiSectionView/shelf/common/addShelfDisplaceGaps';
import { isEven, isOdd } from '@Utils/miscUtils';
import { pipeAsyncTransformer } from '@Utils/pipeAsync';
import { pipeWith } from 'ramda';

export const addFooter = pipeWith(pipeAsyncTransformer, [
  addShelfDisplaceGaps(doubleIndexChecker(isOdd)),
  layoutJumps,
  addShelfDisplaceGaps(doubleIndexChecker(isEven)),
]);
